import { useMemo, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function useNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeSection = useMemo(() => {
    switch (location.pathname) {
      case '/sanctuary': return 'destinations';
      case '/experiences': return 'experiences';
      case '/planner': return 'planner';
      case '/retreats': return 'booking';
      case '/guide': return 'aiguide';
      case '/stories': return 'testimonials';
      default: return 'hero';
    }
  }, [location.pathname]);

  const navigateToSection = useCallback((id) => {
    const routeMap = {
      hero: '/',
      destinations: '/sanctuary',
      experiences: '/experiences',
      planner: '/planner',
      booking: '/retreats',
      aiguide: '/guide',
      testimonials: '/stories',
    };
    navigate(routeMap[id] || '/');
  }, [navigate]);

  const hideHeaderFooter = ['/login', '/signup', '/admin'].includes(location.pathname);

  return { activeSection, navigateToSection, hideHeaderFooter, location };
}